import LogoScroll from "./LogoScroll";
import RestaurantSuccess from "./RestaurantSuccess";
import Plans from "./Plans";
import BusinessImpact from "./BusinessImpact";
import WhyChooseUs from "./WhyChooseUs";
import { Scanner } from "./Scanner";
import PricingSection from "./PricingSection";
import FaqSection from "./FAQ";
import GetInTouch from "./GetInTouch";
import Footer from "./Footer";
import InstantBilling from "./InstantBilling";
import Navbar from "./Navbar";
import BuiltForBusiness from "./BuiltForBusiness";
import CtaSection from "./CTASection";
import HeroSection from "./HeroSection";

const Home = () => {

  return (
    <>
      <Navbar />
      <HeroSection />
      <BuiltForBusiness />
      <CtaSection />
      <InstantBilling />
      <LogoScroll />
      <RestaurantSuccess />
      {/* <Plans /> */}
      <BusinessImpact />
      <WhyChooseUs />
      <Scanner />
      {/* <PricingSection /> */}
      <FaqSection />
      <GetInTouch />
      <Footer />
    </>
  );
};

export default Home;
